import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';

const GOOGLE_MAPS_KEY_TOKEN = '[GOOGLE_MAPS_API_KEY]';
const GOOGLE_MAPS_FUNCTION = `(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=\`https://maps.$\{c}apis.com/maps/api/js?\`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({v: "weekly",key: "${GOOGLE_MAPS_KEY_TOKEN}"});`;

@Injectable({
  providedIn: 'root',
})
export class GoogleMapService {
  private document = inject<Document>(DOCUMENT);

  private mapId$$ = new BehaviorSubject<string | null>(null);

  mapId$ = this.mapId$$.asObservable();
  initialized$ = this.mapId$$.pipe(map(Boolean));

  appendGoogleMapsScript(apiKey: string, mapId: string): void {
    if (this.mapId$$.getValue()) {
      return;
    }

    this.mapId$$.next(mapId);

    const script = this.document.createElement('script');
    script.append(GOOGLE_MAPS_FUNCTION.replace(GOOGLE_MAPS_KEY_TOKEN, apiKey));
    this.document.body.appendChild(script);
  }
}
